@if (isOpen()) {
  <div class="fixed inset-0 z-50">
    <button
      type="button"
      class="absolute inset-0 backdrop-blur-[2px] bg-black/20"
      aria-label="Chiudi finestra"
      (click)="requestClose()"
    ></button>

    <div class="absolute inset-0 flex items-center justify-center p-1">
      <div
        class="relative flex h-[95vh] w-full max-w-8xl flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900"
        role="dialog"
        aria-modal="true"
        aria-labelledby="validation-dialog-title"
      >
        <div
          class="flex items-center justify-between border-b border-gray-100 px-5 py-2 dark:border-gray-800"
        >
          <div class="flex items-center gap-3">
            @if (violations().length > 0) {
              <span
                class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30"
              >
                <svg
                  class="h-4 w-4 text-red-600 dark:text-red-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </span>
            } @else {
              <span
                class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/30"
              >
                <svg
                  class="h-4 w-4 text-emerald-600 dark:text-emerald-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </span>
            }
            <div>
              <h3
                id="validation-dialog-title"
                class="text-base font-semibold text-gray-900 dark:text-white"
              >
                Verifica Dati
                @if (tipoDocumento()) {
                  <span
                    class="ml-1.5 inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-400"
                  >
                    {{ tipoDocumento() || '' | comparisonLabel: 'document_type' }}
                  </span>
                }
                @if (violations().length > 0) {
                  <span
                    class="ml-1.5 inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-400"
                  >
                    {{ violations().length }}
                  </span>
                }
              </h3>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                @if (violations().length > 0) {
                  Seleziona le violazioni da notificare o crea un nuovo messaggio.
                } @else {
                  Nessuna violazione trovata. Puoi comunque creare un messaggio manuale.
                }
              </p>
            </div>
          </div>
          <button
            type="button"
            (click)="requestClose()"
            [disabled]="isLoading()"
            class="inline-flex h-7 w-7 items-center justify-center cursor-pointer rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300 disabled:opacity-50"
            aria-label="Chiudi finestra"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div class="min-h-0 flex-1 overflow-hidden">
          <div class="grid h-full min-h-0 gap-2 p-2 lg:grid-cols-[1fr_2fr]">
            <div
              class="flex min-h-0 flex-col overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700"
            >
              @if (hasViolations()) {
                <div
                  class="flex items-center justify-between gap-3 border-b border-gray-100 bg-gray-50/50 px-4 dark:border-gray-800 dark:bg-gray-800/30"
                >
                  <div class="flex items-center gap-2">
                    <input
                      type="checkbox"
                      [checked]="isAllSelected()"
                      [indeterminate]="isSomeSelected()"
                      (change)="toggleAll()"
                      class="h-3.5 w-3.5 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                      aria-label="Seleziona tutte le violazioni"
                    />
                    <span class="text-xs text-gray-500 dark:text-gray-400">
                      @if (selectedCount() > 0) {
                        {{ selectedCount() }} di {{ violations().length }} selezionate
                      } @else {
                        Seleziona tutto
                      }
                    </span>
                  </div>

                  <button
                    type="button"
                    (click)="addCustomDraft()"
                    class="inline-flex my-1.5 cursor-pointer shrink-0 items-center gap-1.5 rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700 transition-colors hover:bg-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50"
                  >
                    <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    Nuovo
                  </button>
                </div>

                <ul
                  class="validation-list-scroll min-h-0 flex-1 divide-y divide-gray-100 overflow-y-auto overscroll-contain dark:divide-gray-800"
                  role="listbox"
                  aria-label="Elenco violazioni"
                >
                  @for (violation of violations(); track $index; let index = $index) {
                    <li
                      class="flex items-start gap-3 px-4 py-3 transition-colors cursor-pointer"
                      [class]="
                        selectedIndexes().has(index)
                          ? 'bg-blue-50/60 dark:bg-blue-900/10'
                          : 'hover:bg-gray-50 dark:hover:bg-gray-800/40'
                      "
                      role="option"
                      tabindex="0"
                      [attr.aria-selected]="selectedIndexes().has(index)"
                      (click)="toggleSelection(index)"
                      (keydown.enter)="toggleSelection(index)"
                      (keydown.space)="$event.preventDefault(); toggleSelection(index)"
                    >
                      <input
                        type="checkbox"
                        [checked]="selectedIndexes().has(index)"
                        (change)="toggleSelection(index)"
                        (click)="$event.stopPropagation()"
                        class="mt-0.5 h-3.5 w-3.5 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                        [attr.aria-label]="'Seleziona violazione: ' + violation.subject"
                      />
                      <div class="min-w-0 flex-1">
                        <div class="flex items-center gap-2">
                          <span
                            class="inline-flex items-center rounded-md bg-gray-100 px-1.5 py-0.5 text-[11px] font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300"
                          >
                            {{ violation.document_type }}
                          </span>

                          <span
                            class="inline-flex items-center rounded-md bg-gray-100 px-1.5 py-0.5 text-[11px] text-gray-500 dark:bg-gray-800 dark:text-gray-400"
                          >
                            {{ violation.document_subtype }}
                          </span>
                        </div>

                        @if (violation.description) {
                          <p class="mt-0.5 text-xs text-gray-600 dark:text-gray-300 leading-snug">
                            {{ violation.description }}
                          </p>
                        }
                        <p class="mt-0.5 text-xs text-red-600 dark:text-red-400 leading-snug">
                          {{ violation.message }}
                        </p>
                      </div>
                    </li>
                  }
                </ul>
              } @else {
                <div class="flex min-h-0 flex-1 items-center justify-center px-6 text-center">
                  <div>
                    <svg
                      class="mx-auto mb-3 h-10 w-10 text-emerald-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Nessuna violazione rilevata
                    </p>
                    <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">
                      Puoi inviare comunque un messaggio manuale dal pannello a destra.
                    </p>
                  </div>
                </div>
              }
            </div>

            <form
              [formGroup]="validationForm"
              class="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700"
            >
              <div
                class="flex items-center gap-2 border-b border-gray-100 bg-gray-50/60 dark:border-gray-800 dark:bg-gray-800/30"
              >
                <div
                  #tabsScroller
                  class="validation-tabs-scroll flex min-w-0 flex-1 items-center gap-1 overflow-x-auto scroll-smooth pr-1"
                  role="tablist"
                  aria-label="Bozze email"
                >
                  @for (draft of emailDrafts(); track draft.id) {
                    <div
                      role="tab"
                      tabindex="0"
                      [id]="'validation-draft-tab-' + draft.id"
                      [attr.aria-controls]="'validation-draft-panel-' + draft.id"
                      [attr.aria-selected]="isDraftActive(draft.id)"
                      [attr.title]="getDraftTabLabel(draft)"
                      (click)="selectDraft(draft.id)"
                      (keydown.enter)="selectDraft(draft.id)"
                      (keydown.space)="$event.preventDefault(); selectDraft(draft.id)"
                      class="group inline-flex h-9 max-w-36 shrink-0 items-center gap-1.5 rounded-t-lg border border-b-0 px-2 text-xs cursor-pointer"
                      [class]="
                        isDraftActive(draft.id)
                          ? 'border-gray-200 bg-white text-gray-900 shadow-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white'
                          : 'border-transparent bg-transparent text-gray-500 hover:bg-white/70 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-900/60 dark:hover:text-gray-200'
                      "
                    >
                      <span
                        class="min-w-0 truncate"
                        [class]="isDraftInvalid(draft.id) ? 'text-red-600 dark:text-red-400' : ''"
                      >
                        {{ getDraftTabLabel(draft) }}
                      </span>
                      @if (draft.kind === 'custom') {
                        <span
                          class="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-blue-100 px-1 text-[9px] font-semibold uppercase tracking-[0.08em] text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
                        >
                          N
                        </span>
                      }
                      <button
                        type="button"
                        class="inline-flex h-4 w-4 items-center cursor-pointer justify-center rounded-full text-gray-400 transition-colors group-hover:bg-gray-100 group-hover:text-gray-600 dark:group-hover:bg-gray-800 dark:group-hover:text-gray-300"
                        aria-label="Chiudi bozza"
                        (click)="$event.stopPropagation(); closeDraft(draft.id)"
                      >
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  }
                </div>

                <div class="flex shrink-0 items-center gap-1">
                  <button
                    type="button"
                    (click)="scrollTabs('left')"
                    class="inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-white hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200"
                    aria-label="Scorri bozze a sinistra"
                  >
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </button>

                  <button
                    type="button"
                    (click)="scrollTabs('right')"
                    class="inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-white hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200"
                    aria-label="Scorri bozze a destra"
                  >
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              @if (activeDraft(); as activeDraft) {
                <div
                  class="flex min-h-0 flex-1 flex-col gap-4 p-3"
                  role="tabpanel"
                  [id]="'validation-draft-panel-' + activeDraft.id"
                  [attr.aria-labelledby]="'validation-draft-tab-' + activeDraft.id"
                >
                  <div>
                    <label
                      for="validation-email-subject"
                      class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-200"
                    >
                      Oggetto email
                    </label>
                    <input
                      id="validation-email-subject"
                      type="text"
                      formControlName="subject"
                      class="h-11 w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:focus:border-blue-400"
                      [class]="
                        subjectControl.invalid && subjectControl.touched
                          ? 'border-red-400 focus:border-red-500 focus:ring-red-100 dark:border-red-500'
                          : ''
                      "
                      placeholder="Inserisci l'oggetto"
                    />
                    @if (subjectControl.invalid && subjectControl.touched) {
                      <p class="mt-1 text-xs text-red-600 dark:text-red-400">
                        L'oggetto è obbligatorio.
                      </p>
                    }
                  </div>

                  <div class="flex min-h-0 flex-1 flex-col">
                    <p class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-200">
                      Corpo email
                    </p>
                    <quill-editor
                      formControlName="body"
                      [modules]="messageEditorModules"
                      [sanitize]="false"
                      format="html"
                      aria-label="Corpo email"
                      placeholder="Scrivi il testo dell'email"
                      class="validation-quill flex min-h-0 flex-1 flex-col rounded-xl border border-gray-200 bg-white text-sm text-gray-700 shadow-sm transition-all focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:focus-within:border-blue-500"
                    ></quill-editor>
                    @if (bodyControl.invalid && bodyControl.touched) {
                      <p class="mt-1 text-xs text-red-600 dark:text-red-400">
                        Il corpo email è obbligatorio.
                      </p>
                    }
                  </div>
                </div>
              } @else {
                <div class="flex min-h-0 flex-1 items-center justify-center p-6 text-center">
                  <div class="max-w-sm">
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Nessuna bozza aperta
                    </p>
                    <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">
                      Seleziona una violazione a sinistra oppure crea un nuovo messaggio manuale.
                    </p>
                    <button
                      type="button"
                      (click)="addCustomDraft()"
                      class="mt-4 inline-flex items-center gap-2 rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
                    >
                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                      Crea nuovo messaggio
                    </button>
                  </div>
                </div>
              }
            </form>
          </div>
        </div>

        <div
          class="flex items-center justify-end gap-2 pr-25 border-t border-gray-100 px-5 py-3 dark:border-gray-800"
        >
          <button
            type="button"
            (click)="requestClose()"
            [disabled]="isLoading()"
            class="rounded-lg px-3 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 disabled:opacity-50 cursor-pointer transition-colors"
          >
            Annulla
          </button>
          <button
            type="button"
            (click)="submit()"
            [disabled]="!canSubmit()"
            class="inline-flex items-center rounded-lg bg-blue-600 px-4 py-1.5 text-sm font-semibold text-white transition-all hover:bg-blue-700 active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
          >
            @if (isLoading()) {
              <svg class="mr-1.5 h-3.5 w-3.5 animate-spin" viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                  fill="none"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            }
            Invia Email
            @if (draftCount() > 0) {
              ({{ draftCount() }})
            }
          </button>
        </div>
      </div>
    </div>
  </div>
}
